// JavaScript Document

var ww = document.body.clientWidth;

jQuery(document).ready(function () {

  jQuery(".header-menu li a").each(function () {

    if (jQuery(this).next().length > 0) {

      jQuery(this).addClass("parent");

    }

    ;

  })

  jQuery(".toggleMenu").click(function (e) {

    e.preventDefault();

    jQuery(this).toggleClass("active");

    jQuery(".main-nav").slideToggle();

  });

  adjustMenu();

})

jQuery(window).bind('resize orientationchange', function () {

  ww = document.body.clientWidth;

  adjustMenu();

});

var adjustMenu = function () {

  if (ww <= 991) {

    jQuery(".toggleMenu").css("display", "inline-block");

    if (!jQuery(".toggleMenu").hasClass("active")) {

      jQuery(".main-nav").hide();

    } else {

      jQuery(".main-nav").show();

    }

    jQuery(".header-menu li").unbind('mouseenter mouseleave');

    jQuery(".header-menu li a.parent").unbind('click').bind('click', function (e) {

      // must be attached to anchor element to prevent bubbling

      e.preventDefault();

      jQuery(this).parent("li").toggleClass("hover");

    });

  } else if (ww > 991) {

    jQuery(".toggleMenu").css("display", "none");

    jQuery(".main-nav").show();

    jQuery(".header-menu li").removeClass("hover");

    jQuery(".header-menu li a").unbind('click');

    jQuery(".header-menu li").unbind('mouseenter mouseleave').bind('mouseenter mouseleave', function () {

      // must be attached to li so that mouseleave is not triggered when hover over submenu

      jQuery(this).toggleClass('hover');

    });

  }

}



jQuery('.carousel-inner').each(function () {

  if (jQuery(this).children('div').length === 1)

    jQuery(this).siblings('.carousel-control-prev, .carousel-control-next, .carousel-indicators').hide();

});



$(window).on("load", function () {


  $('#carousel').flexslider({

    animation: "slide",

    controlNav: false,

    animationLoop: false,

    slideshow: false,

    itemWidth: 90,

    itemMargin: 15,

    asNavFor: '#slider'

  });



  jQuery('#slider').flexslider({

    animation: "slide",

    controlNav: false,

    animationLoop: false,

    slideshow: false,

    sync: "#carousel",

    start: function(slider){

      $('body').removeClass('loading');

    }

  });

});


jQuery(document).ready(function() {

  var owl = jQuery('.CarouselOwl');

  owl.owlCarousel({

    nav: false,  
    autoplayTimeout:4000,
    autoplayHoverPause:false,
    margin:15,
    loop: true,  
    responsive: {

      0: {items: 1},

      480: {items: 1},

      576: {items: 1},

      768: {items: 1},

      992: {items: 1},

      1200: {items: 1}

    }

  });

});

jQuery(document).ready(function() {

  var owl = jQuery('.CarouselOwl1');

  owl.owlCarousel({
    nav: false,
    autoplayTimeout:4000,
    autoplayHoverPause:false,
    margin: 30,
    loop: true,
    items: 1,
    stagePadding: 100,
    responsiveClass:true,
    responsive: {
      0: {items: 1},
      480: {items: 1},
      576: {items: 1},
      768: {items: 1},
      992: {items: 1},
      1200: {items: 1}

    }

  });

});


jQuery(document).ready(function(){

  jQuery(".toggle_container").hide(); 

  jQuery(".trigger").click(function(){

    jQuery(this).toggleClass("activefaq").next().slideToggle("700");

    return false;

  });

});

jQuery(document).ready(function() {
  jQuery('.back_collection').click(function(){
    var referrer =  document.referrer;
    var n = referrer.includes("collections");
    if(n){
      window.location.href = referrer;
    }else {
    	var href = jQuery(this).attr('rhref');
        window.location.href = href;
    }
  });
});




jQuery(function () {

  jQuery(".img-crop").responsiveImageCropper();

});


!function (e) {

  var t = function () {};

  t.prototype = {targetElements: void 0, options: void 0, run: function (e) {

                 var t = this;

                 this.targetElements = new Array, e.each(function (e) {

                 var i = jQuery(this);

                 i.css({display: "none"});

  var a = new Image;

  a.onload = function () {

    i.css({position: "absolute"}), t.targetElements.push(i), t.croppingImageElement(i), i.css({display: "block"})

  }, a.src = i.attr("src")

}), jQuery(window).resize(function (e) {

  t.onResizeCallback()

})

}, onResizeCallback: function () {

  var t = this;

  e.each(this.targetElements, function (e) {

    var i = this;

    t.croppingImageElement(i)

  })

}, croppingImageElement: function (t) {

  var i, a;

  t.data("crop-image-wrapped") ? (a = t.data("crop-image-outer"), i = t.data("crop-image-inner")) : (a = e("<div>"), i = e("<div>"), a.css({overflow: "hidden", margin: t.css("margin"), padding: t.css("padding")}), t.css({margin: 0, padding: 0}), i.css({position: "relative", overflow: "hidden"}), t.after(a), a.append(i), i.append(t), t.data("crop-image-outer", a), t.data("crop-image-inner", i), t.data("crop-image-wrapped", !0)), this.desideImageSizes(t)

}, desideImageSizes: function (e) {

  var t = e.data("crop-image-outer"), i = e.data("crop-image-inner"), a = e.data("crop-image-ratio");

  a || (a = 1);

  var n = t.width() * a;

  i.height(n), e.width(t.width()), e.height("auto"), e.css({position: "absolute", left: 0, top: -(e.height() - t.height()) / 2}), n > e.height() && (e.width("auto"), e.height(n), e.css({position: "absolute", left: -(e.width() - t.width()) / 2, top: 0}))

}, setOptions: function (e) {

  this.options = e

}}, e.fn.responsiveImageCropper = function (i) {

  var i = e.extend(e.fn.responsiveImageCropper.defaults, i), a = e(this);

  return cropper = new t, cropper.setOptions(i), cropper.run(a), this

}, e.fn.responsiveImageCropper.defaults = {}

}(jQuery);

$(".banner_button").click(function() { 
  var href = $(this).attr('href');
  if( href == 'javascript:void(0)' ){
    if($(".impact_section").length > 0) {
      $('html, body').animate({
        scrollTop: $(".impact_section").offset().top
      }, 1000);    
    }
  }
});

$(".request_consult").click(function() {

  window.location.href="/pages/contact-us"

});

$(document).ready(function() {
  $(".continue_shopping").on("click",function(){ 
    $.fancybox.close();
  });
});
$('.pro_review').click(function(){
  $('html, body').animate({
    scrollTop: $(".product-tabs").offset().top 
  }, 1000);
  $('#Reviews-tab').click();
});
$('.req_form').click(function(){
  $('html, body').animate({
    scrollTop: $(".request_consult_form").offset().top 
  }, 1000);
});
$('.addTocart').click(function(){
  var id = jQuery(this).attr('v-id'); 
  var isLink = false;
  var obj = jQuery(this);
  if(obj.hasClass('link')){
    isLink = true;
  }
  if(isLink){
    obj.text('ADDING..')
  }
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {id:id,quantity:1},
    dataType: 'json',
    success: function(response){
      $.fancybox({
        href: "#addedCart",
        'width'  : 400,
        'padding': 0,
        'height' : 150,
        'autoSize' : false
      });
      if(isLink){
        obj.text('ADD TO CART')
      }
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cartdata){ 
          $('.minicart').html('<span>'+cartdata.item_count+'</span>')
        }
      });
    },
    error : function(xhr){ 
      if(xhr.responseJSON.status = 422){
        alert(xhr.responseJSON.description);
      }
    }
  });
});

jQuery(".update_cart").on("click",function(){ 
  jQuery(this).parents('form').submit();
});
$(".content-li h4").on("click", function(){
  $(this).toggleClass("selected").parent(".content-li").siblings(".content-li").find("h4").removeClass("selected");
  $(this).next(".content-rte").slideToggle().parent(".content-li").siblings(".content-li").find(".content-rte").slideUp();
});
$(document).ready(function(){
  $('.thumb').click(function(){
    var largeImage = $(this).attr('data-full');
    $('.selected').removeClass();
    $(this).addClass('selected');
    $('.full img').hide();
    $('.full img').attr('src', largeImage);
    $('.full img').fadeIn();


  }); // closing the listening on a click
  $('.full img').on('click', function(){
    var modalImage = $(this).attr('src');
    $.fancybox.open(modalImage);
  });
});



function CopyToClipboard(containerid) {
  var range = document.createRange();
  range.selectNode(containerid); 
  window.getSelection().removeAllRanges(); 
  window.getSelection().addRange(range); 
  document.execCommand("copy");
  window.getSelection().removeAllRanges();
  alert("Copied");
}